import React, { createContext, useContext } from 'react';
import { setLocale } from './dates';
import { getPortalByName } from './portals';

export const LangContext = createContext<string>('da');
export const useLangContext = (): string => {
  const lang = useContext(LangContext);
  setLocale(lang);
  return lang;
};

export const AuthenticationContext = createContext<boolean>(false);
export const useAuthenticationContext = (): boolean => useContext(AuthenticationContext);

export const UserContext = createContext<AU.IUserContext | null>(null);
export const useUserContext = (): AU.IUserContext | null => {
  const user = useContext(UserContext);
  return user;
};

export const PortalContext = createContext<AU.IPortalContext | null>(null);

type PortalContextProviderProps = {
  name: AU.portalNames;
  children: JSX.Element;
}

export const AUPortal = {
  Provider: ({
    name,
    children,
  }: PortalContextProviderProps) => {
    const lang = useLangContext();
    const portal = getPortalByName(lang || 'da', name);
    return (
      <PortalContext.Provider value={portal}>
        <AuthenticationContext.Provider value={typeof window.authenticated === 'undefined' ? false : window.authenticated}>
          {children}
        </AuthenticationContext.Provider>
      </PortalContext.Provider>
    );
  },
};

export const usePortalContext = (): AU.IPortalContext | null => {
  const portal = useContext(PortalContext);
  return portal;
};

export const ImpersonationContext = createContext<AU.IImpersonationContext>({
  canImpersonate: false,
  isImpersonating: false,
  impersonatateError: false,
});
// eslint-disable-next-line max-len
export const useImpersonationContext = (): AU.IImpersonationContext => useContext(ImpersonationContext);
